import { TabPanel, TabView } from "primereact/tabview"
import { PathNormativitiesTabPanelContent } from "./pathNormativitiesTabPanelContent"
import { useLayoutEffect, useRef, useState } from "react";

type PathNormativitiesTabViewProps = {
    paths: any
}

export function PathNormativitiesTabView({ paths }: PathNormativitiesTabViewProps) {

    const containerRef = useRef<HTMLDivElement>(null);
    const [scrollable, setScrollable] = useState(false);

    useLayoutEffect(() => {
        const nav = containerRef.current?.querySelector<HTMLElement>('.p-tabview-nav');
        if (nav) {
            setScrollable(nav.scrollWidth > nav.clientWidth);
        }
    }, [paths.length]);


    return (
        <div className="path-normativities-section-div" ref={containerRef}>
            <TabView className="path-normativities-tab-view" panelContainerClassName="path-normativities-tab-panel-content" scrollable={scrollable}>
                {paths.map((path: any) => {
                    const { Name, PathID } = path ?? {}
                    return (
                        <TabPanel header={Name}>
                            <PathNormativitiesTabPanelContent pathId={PathID} />
                        </TabPanel>
                    )
                })}
            </TabView>
        </div>
    )
}
